import { render, staticRenderFns } from "./AddDocumentItemPage.vue?vue&type=template&id=746e6a26&scoped=true&"
import script from "./AddDocumentItemPage.vue?vue&type=script&lang=js&"
export * from "./AddDocumentItemPage.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentItemPage.vue?vue&type=style&index=0&id=746e6a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e6a26",
  null
  
)

export default component.exports